// store toggle
const toggleButton = document.getElementById('toggle-content');
const toggleExtendedContent = document.querySelector(
  '.toggle-content__extended'
);

if (toggleButton) {
  toggleButton.addEventListener('click', function() {
    // on click, toggle the extended content open/closed
    const toggleStatus = toggleExtendedContent.getAttribute('aria-expanded');
    if (toggleStatus === 'true') {
      toggleExtendedContent.setAttribute('aria-expanded', 'false');
    } else {
      toggleExtendedContent.setAttribute('aria-expanded', 'true');
    }

    /* Moved into templates/art-archive.twig to get content from custom fields */
    // // on click, toggle the button text
    // if (toggleButton.innerHTML === 'Learn More') {
    //   toggleButton.innerHTML = 'Show Less';
    // } else {
    //   toggleButton.innerHTML = 'Learn More';
    // }
  });

  toggleButton.addEventListener('keyup', event => {
    // after spacebar or enter key press, use click function ^
    if (event.key === 'Space' || event.key === '13') {
      toggleButton.click();
    }
  });
}
